// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import { PREFILL_DATA_SAVED } from 'actions/prefillDataSaved';
import { PREFILL_HAS_NO_MATCH } from 'actions/prefillNoMatch';
import { PREFILL_PHONE_IS_INELIGIBLE } from 'actions/prefillPhoneIneligible';
import { PREFILL_VARIANT_1 } from 'actions/prefillVariant1';

export const initialState = {
  address: {
    address: '',
    address2: '',
    city: '',
    state: '',
    zipcode: '',
  },
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  prefillPhoneIneligible: false,
  prefillNoMatch: false,
  prefillVariant1: false,
};

/* eslint-disable default-case, no-param-reassign */
const prefillDataReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { payload, type } = action;
    switch (type) {
      case PREFILL_VARIANT_1:
        draft.prefillVariant1 = true;
        break;
      case PREFILL_DATA_SAVED:
        mapAddressToPayload(draft, payload.address, initialState.address);
        draft.firstName = payload.firstName;
        draft.lastName = payload.lastName;
        draft.dateOfBirth = payload.dateOfBirth;
        break;
      case PREFILL_PHONE_IS_INELIGIBLE:
        draft.prefillPhoneIneligible = true;
        break;
      case PREFILL_HAS_NO_MATCH:
        draft.prefillNoMatch = true;
        break;
    }
  });

export default prefillDataReducer;

const mapAddressToPayload = (draft, addressData, addressState) => {
  Object.keys(addressState).forEach(key => {
    const prefillValue = addressData[key];
    if (prefillValue) {
      draft.address[key] = prefillValue;
    }
  });
};
